import http from "@/http/aisea/axios";
const resource = "/enterprises/units";

export default {
  fetchUnits(params) {
    return http.get(`${resource}`, {
      params: params,
    });
  },
};
